import type { LucideIcon } from "lucide-react";
import { roasTier } from "@scandi/shared";
import { cn } from "@/lib/utils";

/** ROAS colour, driven by the admin-configured green threshold. */
export function roasClass(roas: number | null, greenThreshold: number): string {
  switch (roasTier(roas, greenThreshold)) {
    case "good":
      return "text-success";
    case "ok":
      return "text-warning";
    case "bad":
      return "text-destructive";
    default:
      return "text-muted-foreground";
  }
}

/**
 * A labelled stat. Label above value, because on a phone the label is what
 * tells you which number you are looking at.
 */
export function MetricChip({
  label,
  value,
  icon: Icon,
  className,
  valueClassName,
}: {
  label: string;
  value: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
  valueClassName?: string;
}) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-0.5", className)}>
      <span className="text-muted-foreground flex items-center gap-1 text-[10px] font-medium tracking-wider uppercase">
        {Icon && <Icon className="size-3 shrink-0" />}
        {label}
      </span>
      <span className={cn("truncate text-sm font-semibold", valueClassName)}>{value}</span>
    </div>
  );
}
